import createError from '../createError';
import type {Params, ValidatorError} from '../types';

export interface AttachmentInput {
  size: number;
  length: number;
}

export function attachmentValidators(
  value: AttachmentInput,
  field: string,
  params: Params
) {
  return {
    attached: () => attached(value, field),
    fileSize: () => fileSize(value, field, params),
  };
}

const attached = (value: AttachmentInput, field: string): ValidatorError => {
  return createError(
    value,
    field,
    'attached',
    (value: AttachmentInput) => value.size <= 0 || value.length < 1
  );
};

const fileSize = (
  value: AttachmentInput,
  field: string,
  params: Params
): ValidatorError => {
  if (value.length) {
    return createError(
      value,
      field,
      'fileSize',
      (value: AttachmentInput) => value[0].size >= params,
      params
    );
  }

  return createError(
    value,
    field,
    'fileSize',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (value: AttachmentInput) => value.size >= params,
    params
  );
};
